// 引入公共模块
import { 
  mergeParams,
  addParamsToLinksHandler,
  pageJumpHandler,
  pageJumpBlankHandler,
  initScrollHandler,
  initNavBarHandler,
} from './common.js';

// 命名空间模式
const App = {
  init() {
    addParamsToLinksHandler(mergeParams()); //为链接添加参数
    pageJumpHandler(); //页面跳转
    pageJumpBlankHandler(); // 页面跳转(新窗口打开)
    initScrollHandler(); // 滚动处理
    initNavBarHandler(); // 导航下拉处理
    this.caSwitchHandler(); // AI技能切换效果
  },
  caSwitchHandler() {
    $('.switch-btn').on('click', function(e) {
      // 阻止默认的点击行为
      e.preventDefault();
      const type = $(this).data('type');
      $('.ca-service-node, .ca-bblk, .ca-connection-line').removeClass('active');
      $(`.node-${type}, .ca-bblk-${type}, .line-${type}`).addClass('active');
    })
  }
};

// 文档加载后初始化
$(function () {
  App.init();
});
